export const LOGO_URL = "/xngs-logo.png";

export const PORTAL_URL =
  "https://myportal.shipngoxpress.com/login?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQPOTM2NjE5NzQzMzkyNDU5AAGnMaoxvZhmWt8LpbHnKtTQeA_Aikso-AO9M_6qpI4K1DgBZCgYRvBJoZmjkjE_aem_377BUEBRuIa94ZzmuYy8Vg";

export const IMAGES = {
  planeSunset:
    "https://images.pexels.com/photos/32037884/pexels-photo-32037884.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  planeTakeoff:
    "https://images.pexels.com/photos/32010721/pexels-photo-32010721.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portNight:
    "https://images.unsplash.com/photo-1508404999913-79a3a2e75437?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  portGreen:
    "https://images.pexels.com/photos/16229885/pexels-photo-16229885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  truckHighway:
    "https://images.unsplash.com/photo-1766785368863-f2188a8c8b32?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  truckTunnel:
    "https://images.pexels.com/photos/20097991/pexels-photo-20097991.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  warehouse:
    "https://images.pexels.com/photos/36522028/pexels-photo-36522028.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  globeMap:
    "https://static.prod-images.emergentagent.com/jobs/dfe8bb72-e08e-4251-850b-d5c1ec81b3dc/images/25906563baf44c07782cec28b4774feecfb7af5c51320f4029a3b4be0f430f4f.png",
  cargoPlane:
    "https://static.prod-images.emergentagent.com/jobs/dfe8bb72-e08e-4251-850b-d5c1ec81b3dc/images/bc55d20877b4dedba51d2ccf34165c034f66236b174061a64545cd2325e2d81a.png",
  shipBox:
    "https://static.prod-images.emergentagent.com/jobs/dfe8bb72-e08e-4251-850b-d5c1ec81b3dc/images/11824cefa1e588c8ec042c014595c863750818f0456a85fc5a6c406c06a357b3.png",
};

export const NAV_LINKS = [
  { label: "Home", href: "#top" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Calculator", href: "#tools" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export const HERO_STATS = [
  { value: "150+", label: "Countries served" },
  { value: "5000+", label: "Deliveries" },
  { value: "99.7%", label: "On-time" },
  { value: "24/7", label: "Support" },
];

export const SERVICES = [
  { key: "air", title: "Air Cargo", desc: "Priority air freight — 3× weekly to Jamaica at competitive rates." },
  { key: "sea", title: "Sea Cargo", desc: "Weekly sailings for barrels, pallets, D-boxes and full container loads." },
  { key: "doortodoor", title: "Door To Door", desc: "We handle the whole journey — collected at origin, delivered to your door." },
  { key: "local", title: "Local Deliveries", desc: "Fast island-wide delivery with real-time driver tracking." },
  { key: "overseas", title: "Overseas Pickups", desc: "We collect from suppliers and stores abroad on your behalf." },
  { key: "customs", title: "Customs Brokerage", desc: "Licensed clearance and duty handling so nothing gets stuck." },
  { key: "sameday", title: "Same-Day Delivery", desc: "Urgent local runs delivered the very same day." },
  { key: "warehouse", title: "Warehousing", desc: "Secure storage, courier packing and customer consolidation." },
];

export const SCHEDULE = [
  { value: "4×", label: "Departures every week", note: "A dependable, consistent shipping cadence" },
  { value: "3×", label: "Air cargo weekly", note: "Fast air freight to Jamaica, three times a week" },
  { value: "1×", label: "Ocean freight weekly", note: "Weekly sailing for larger, budget-friendly loads" },
];

export const JOURNEY = [
  { key: "pickup", title: "Pickup", desc: "We collect from your door or warehouse." },
  { key: "warehouse", title: "Warehouse", desc: "Scanned, packed and consolidated." },
  { key: "airport", title: "Airport", desc: "Loaded and cleared for departure." },
  { key: "customs", title: "Customs", desc: "Documentation and duties handled." },
  { key: "delivery", title: "Out for Delivery", desc: "On the final leg to you." },
  { key: "delivered", title: "Delivered", desc: "Signed, tracked and complete." },
];

export const WHY_STATS = [
  { value: 99.7, suffix: "%", label: "On-Time Delivery" },
  { value: 150, suffix: "+", label: "Countries" },
  { value: 24, suffix: "/7", label: "Customer Support", raw: "24/7" },
  { value: 5000, suffix: "+", label: "Successful Deliveries" },
  { value: 15, suffix: "+", label: "Years Experience" },
];

export const COMPARISON = [
  { label: "Competitive, all-in rates", us: true, them: false, themNote: "Hidden fees" },
  { label: "Real-time shipment tracking", us: true, them: false, themNote: "Slow updates" },
  { label: "Dedicated customer support", us: true, them: false, themNote: "Slow support" },
  { label: "4× weekly departures", us: true, them: false, themNote: "Irregular" },
  { label: "Customs handled for you", us: true, them: false, themNote: "You're on your own" },
];

export const REVIEWS = [
  {
    quote:
      "SNGX is an excellent choice for me and my growing company — they help with sourcing my cargo, shipping it and clearing it. Number one shipping option!",
    name: "Makaio Francis",
    role: "Small business owner",
  },
  {
    quote:
      "My family and I have been shipping with SNGX for a while now, and we've truly become part of their family. Fastest courier company I've used.",
    name: "Ricardo Bennett",
    role: "Loyal family customer",
  },
  {
    quote:
      "The service here is very professional. Great communication, and the turnaround time is always on point. Affordable international shipping.",
    name: "Kimani Khaleel",
    role: "Verified customer",
  },
];

export const HOW_STEPS = [
  { n: "01", title: "Sign up", desc: "Create your free account and get a personal US shipping address in minutes." },
  { n: "02", title: "Pre-alert us", desc: "Shop online and let us know what's on the way so we match it on arrival." },
  { n: "03", title: "Choose your service", desc: "Pick air or sea, add consolidation, and we handle sourcing and customs." },
  { n: "04", title: "Receive your shipment", desc: "Collect in Jamaica or have it delivered right to your door." },
];

export const FAQS = [
  { q: "How long does shipping take?", a: "Air cargo to Jamaica arrives within days thanks to 3× weekly departures; ocean freight sails weekly for larger loads. Your exact estimate is shown instantly in the rate calculator." },
  { q: "Can I ship internationally?", a: "Yes — we deliver to 150+ countries with international courier, air and ocean freight, plus full customs handling." },
  { q: "Do you offer tracking?", a: "Every shipment streams live milestones from pickup to delivery, with proactive alerts. Track any shipment right on this page." },
  { q: "What items are prohibited?", a: "Hazardous materials, flammables, illegal goods and restricted items can't be shipped. Contact us if you're unsure about a specific item." },
  { q: "How do I insure a package?", a: "Just toggle insurance on in the rate calculator before you ship — full-value all-risk cover is added for total peace of mind." },
];

export const HUBS = [
  { name: "Canada", city: "Toronto", left: 25, top: 31, time: "1–2 days", role: "origin" },
  { name: "USA", city: "Miami", left: 28, top: 45, time: "1–2 days", role: "origin" },
  { name: "China", city: "Shenzhen", left: 80, top: 45, time: "3–5 days", role: "origin" },
  { name: "Jamaica", city: "Kingston", left: 31, top: 58, time: "Home base", role: "dest" },
];

export const SOCIALS = [
  { label: "WhatsApp", href: "https://wa.me/18765386101" },
  { label: "Instagram", href: "http://instagram.com/xpressngoship" },
  { label: "Facebook", href: "https://www.facebook.com/ShipNGoXpress" },
  { label: "LinkedIn", href: "https://www.linkedin.com/" },
];

export const WHATSAPP_URL = "https://wa.me/18765386101";

export const PHONES = ["876 825 6468", "876 538 6101", "876 826 1828"];
export const WEBSITE = "www.xpressngoship.com";

export const LOCATIONS = [
  { name: "Williamsfield Branch", address: "Shop 2, Williamsfield Pen, Williamsfield, Manchester, Jamaica" },
  { name: "Junction Branch", address: "Rateeth Lawn, Junction, St. Elizabeth, Jamaica" },
];

export const PROHIBITED = [
  { key: "flammable", title: "Flammables & gases", desc: "Aerosols, lighters, fuel, paint, camping gas." },
  { key: "weapons", title: "Weapons & ammunition", desc: "Firearms, replicas, ammunition, explosives." },
  { key: "drugs", title: "Illegal drugs", desc: "Narcotics and any controlled/illegal substances." },
  { key: "perishable", title: "Perishables", desc: "Unpreserved food, plants and live animals." },
  { key: "cash", title: "Cash & valuables", desc: "Currency, precious stones and unbanked jewelry." },
  { key: "hazard", title: "Hazardous materials", desc: "Corrosives, toxic, radioactive or biohazard goods." },
];

export const SHIP_TIPS = [
  "Double-box fragile items and use plenty of cushioning.",
  "Keep your commercial invoice inside and a copy outside.",
  "Pre-alert every shipment so we match it the moment it lands.",
  "Add insurance in the calculator for high-value orders.",
];

export const COUNTRIES = [
  "United States", "Jamaica", "Canada", "United Kingdom", "China", "Trinidad & Tobago",
  "Barbados", "Cayman Islands", "Bahamas", "Panama", "Mexico", "Germany",
  "United Arab Emirates", "India", "Japan", "Australia", "Brazil", "South Africa",
];

export const PACKAGE_TYPES = [
  { value: "document", label: "Document" },
  { value: "parcel", label: "Parcel / Box" },
  { value: "barrel", label: "Barrel" },
  { value: "pallet", label: "Pallet / Freight" },
];

export const SERVICE_LEVELS = [
  { value: "express", label: "Express" },
  { value: "economy", label: "Economy" },
];
